import { render, staticRenderFns } from "./TransportadoraDetalhesLocaisColeta.vue?vue&type=template&id=e0c86072"
import script from "./TransportadoraDetalhesLocaisColeta.vue?vue&type=script&lang=js"
export * from "./TransportadoraDetalhesLocaisColeta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports